import { render } from "./GrupoSocioNegocioList.vue?vue&type=template&id=6264cd1a&scoped=true"
import script from "./GrupoSocioNegocioList.vue?vue&type=script&lang=js"
export * from "./GrupoSocioNegocioList.vue?vue&type=script&lang=js"

import "./GrupoSocioNegocioList.vue?vue&type=style&index=0&id=6264cd1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6264cd1a"]])

export default __exports__